import contactImg from '../../assets/contact.jpg'; 

import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";


const ContactUs = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
    <Container fluid className="contact-us-section py-5 d-flex justify-content-center align-items-center" style={{height:'85vh'}}>
      <Row className="w-100">
        <Col
          md={6}
          className="d-flex justify-content-center align-items-center"
          data-aos="fade-right"
        >
          <img
            src={contactImg} 
            alt="Logistics"
            className="img-fluid"
            style={{ maxWidth: "70%" }} 
          />
        </Col>

        <Col
          md={6}
          className="d-flex justify-content-center align-items-center"
          data-aos="fade-left"
        >
          <div className="contact-info text-center">
            <h2 className="mb-4">Contact Us</h2>
            <p className="lead mb-4 " >
              Let Shivek Group help you streamline your logistics operations. Contact us today to learn how we can provide tailored solutions for your business.
            </p>
            <div className="contact-details">
              <div className="contact-item mb-3">
                <FaPhoneAlt className="mr-2" />
                <span>Phone: 9424809020, 7869085006</span>
              </div>
              <div className="contact-item mb-3">
                <FaEnvelope className="mr-2" />
                <span>Email: shiveke@gmail.com</span>
              </div>
              <div className="contact-item mb-3">
                <FaMapMarkerAlt className="mr-2" />
                <span>Address: Bhopal, M.P.</span>
              </div>
            </div>
            
          </div>
        </Col>
      </Row>
    </Container>
    </>
  );
};

export default ContactUs;
